export const ItemTypes = {
	COMPONENT: "component",
	SINGLE_COLUMN_COMPONENT: "singleColumnComponent",
	SECTIONS_CARD: "card",
	CHECKBOX_ITEM_COMPONENT: "checkboxItemComponent",
	RADIO_ITEM_COMPONENT: "radioItemComponent",
	SELECT_ITEM_COMPONENT: "selectItemComponent",
	FILE_ITEM_COMPONENT: "fileInputItemComponent",
};
